<template>
  <div class="order">
    <div class="order__container">
      <div class="order__container_nav">
        <h4 class="order__container_nav--h4">تاریخچه سفارشات</h4>
        <ul class="order__container_nav--ul">
          <li
            v-on:click="(conid = '2'), refresh_con()"
            v-bind:class="[conid === '2' ? 'accccc2' : '']"
            class="order__container_nav--ul-li"
          >
            پرداخت شده
          </li>
          <li
            v-on:click="(conid = '3'), refresh_con()"
            v-bind:class="[conid === '3' ? 'accccc2' : '']"
            class="order__container_nav--ul-li"
          >
            در حال پردازش
          </li>
          <li
            v-on:click="(conid = '4'), refresh_con()"
            v-bind:class="[conid === '4' ? 'accccc2' : '']"
            class="order__container_nav--ul-li"
          >
            ارسال شده
          </li>
          <li
            v-on:click="(conid = '5'), refresh_con()"
            v-bind:class="[conid === '5' ? 'accccc2' : '']"
            class="order__container_nav--ul-li"
          >
            مرجوعی
          </li>
          <li
            v-on:click="(conid = '6'), refresh_con()"
            v-bind:class="[conid === '6' ? 'accccc2' : '']"
            class="order__container_nav--ul-li"
          >
            لغو شده
          </li>
        </ul>
      </div>
      <div
        class="order__container_list"
        :key="(item, index)"
        v-for="(item, index) in list.results"
      >
        <div class="order__container_list--detail">
          <p style="direction: rtl" class="order__container_list--detail--date">
            تاریخ : &lrm;{{
              item.pay_datetime_jalali.toLocaleString("fa").toPersianDigits()
            }}
            <!-- {{ item.pay_datetime_jalali | moment("DD") }},
            {{ item.pay_datetime_jalali | moment("MM") }},
            {{ item.pay_datetime_jalali | moment("YYYY") }} -->
          </p>
          <p class="order__container_list--detail--id">{{ item.invoice_no }}</p>
          <p v-if="item.total_price" class="order__container_list--detail--pri">
            قیمت کل :
            {{ item.total_price.toLocaleString("fa").toPersianDigits() }}
          </p>
          <!-- <a href=""></a> -->
          <router-link
            href=""
            :to="{ name: 'orderdea', params: { id: item.id } }"
            class="order__container_list--detail--a"
          >
            مشاهده سفارش &nbsp; &nbsp; &nbsp; &rsaquo;
          </router-link>
          <input type="hidden" :value="item.id" />
        </div>
        <div class="order__container_list--items">
          <router-link
            :key="(item, index)"
            v-for="(item, index) in item.orders"
            :to="{ name: 'detail', params: { id: item.slug } }"
            class="order__container_list--items-item"
          >
            <img
              :src="item.image"
              alt=""
              class="order__container_list--items-item--img"
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      conid: "2",
      list: [],
      //   moment: require("jalali-moment").locale("fa")
    };
  },
  methods: {
    detailorder(e) {
      //   console.log(e.target.nextElementSibling.value);
      localStorage.setItem("orderid", e.target.nextElementSibling.value);
      this.$router.push("/profile/myorder/detail");
    },
    refresh_con() {
      // console.log("red");
      var that = this;
      that.$store.state.load = true;
      $.ajax({
        url:
          that.$store.state.url +
          "api/v1/shop/invoice/list/" +
          this.conid +
          "/",
        crossDomain: true,
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data);
          that.list = data;
          //   var moment = require("jalali-moment");
          //   moment.locale("fa");
          //   console.log(
          //     that
          //       .moment(data.pay_datetime)
          //       .add("days")
          //       .format("YYYY")
          //   );
          //   console.log(
          //     that
          //       .moment(data.pay_datetime)
          //       .add("days")
          //       .format("MMMM")
          //   );
          //   console.log(
          //     that
          //       .moment(data.pay_datetime)
          //       .add("days")
          //       .format("DD")
          //   );
          that.$store.state.load = false;
        },
        error: function (request, textStatus, errorThrown) {
          // console.log("blue");
        },
        complete: function () {},
      });
    },
  },
  created() {
    var that = this;
    // this.moment.locale("fa");
    that.$store.state.load = true;
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };
    $.ajax({
      url:
        that.$store.state.url + "api/v1/shop/invoice/list/" + this.conid + "/",
      crossDomain: true,
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("profile"),
      },
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        // console.log(data);
        that.list = data;

        that.$store.state.load = false;
      },
      error: function (request, textStatus, errorThrown) {
        // console.log("blue");
      },
      complete: function () {},
    });
  },
};
</script>
<style lang="scss">
.order {
  width: 100%;
  min-height: 50vh;
  margin-top: 7.9em;
  background: var(--bg-color);
  direction: rtl;
  padding: 4em;
  @media screen and (max-width: 800px) {
    font-size: 0.6em;
  }
  @media screen and (max-width: 500px) {
    font-size: 0.4em;
  }
  &__container {
    background: var(--main-color);
    padding: 2em;
    border-radius: 8px;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.192);
    &_nav {
      display: flex;
      flex-direction: column;
      width: 100%;
      &--h4 {
        margin-bottom: 1em;
        color: var(--shrink);
      }
      &--ul {
        display: flex;
        // border-bottom: 1px solid var(--bg-color);
        &-li {
          //   margin-left: 0.5em;
          padding: 1.5em 2em;
          cursor: pointer;
          //   background: var(--bg-color);
        }
      }
    }
    &_list {
      width: 100%;
      min-height: auto;
      //   margin-top: 1em;
      display: flex;
      flex-direction: column;
      //   justify-content: center;
      &:last-child {
        // background: red;
        border-bottom: 1px solid var(--bg-color);
      }
      &--items {
        padding: 2em;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        // background: red;
        border: 1px solid var(--bg-color);
        border-bottom: none;
        flex-wrap: wrap;
        &-item {
          margin-left: 2em;
          width: 5%;
          // background: red;
          display: flex;
          flex-wrap: wrap;
          @media screen and (max-width: 500px) {
            width: 20%;
            margin: 1em;
          }
          &--img {
            width: 100%;
          }
        }
      }
      &--detail {
        // direction: rtl;
        display: flex;
        padding: 2em;
        // border-radius: 5px;
        border-top: 1px solid var(--bg-color);
        border-left: 1px solid var(--bg-color);
        border-right: 1px solid var(--bg-color);
        &--a {
          margin-right: auto;
          text-decoration: none;
          color: var(--shrink);
        }
        &--date {
          direction: ltr;
          text-align: left;
          // direction: rtl !important;
          margin-left: 1em;
        }
        &--id {
          margin-left: 1em;
        }
        &--pri {
          margin-left: 1em;
        }
      }
    }
  }
}
.accccc2 {
  border-bottom: 1px solid var(--shrink);
}
</style>



// WEBPACK FOOTER //
// src/components/user/userDetail/myorder.vue